<template>
  <div>
    <b-modal id="vueMainModal" v-model="modalShow" :size="size">
      <template #modal-title>        
          <portal-target name="modal-title"></portal-target>      
      </template>

      <b-overlay :show="loading && loading_id == currentRoute.name" rounded="sm" :opacity="opacity">
        <router-view name="modal"></router-view>
        <template #overlay>
          <div class="text-center">
            <loading />
          </div>
        </template>
      </b-overlay>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="outline-secondary"
            class="float-right"
            @click="modalShow = false"
          >
            Fechar
          </b-button>
          <b-button
            type="submit"
            v-if="btn_save"
            :form="form"
            class="float-right"
            variant="outline-secondary"
            ><span v-if="!loading_btn"> <i class="fas fa-save"></i> Salvar</span>
            <span v-else>
              <b-spinner></b-spinner>
              Processando...
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      opacity: 0.5,
      modalShow: false,
      open: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  watch: {
    currentRoute(newRoute, oldRoute) {
      this.openModal();
    },
  },
  computed: {
    ...mapState("modal_route", ["size", "form", "btn_save"]),
    ...mapState("current_route", ["currentRoute"]),
    ...mapState("loading", ["loading", "loading_id", "loading_btn"]),
  },
  mounted() {
    this.openModal();

    // this.$nextTick(function () {
    //   console.log("rotar depois de atualizar", this.$route);

    // });
  },
  updated() {
    this.$nextTick(function () {
      if (this.modalShow == false && this.currentRoute.meta.modal) {      
        this.closeModal();
      }
    });
  },
  methods: {
    ...mapMutations("modal_route", [
      "setSize",
      "btnSave",
      "setForm",
      "btnLoading",
    ]),
    ...mapMutations("loading", ["statusBtn", "setLoadId"]),
    openModal() {
      if (this.currentRoute.meta.modal && this.modalShow == false) {
          this.setLoadId(this.currentRoute.name);
        this.modalShow = true;
      }
    },
    closeModal() {
      this.btnSave(false);
      this.setForm("#");
      this.btnLoading(false);
      this.$router.push({ name: this.currentRoute.meta.redirect }).catch(error => {
  if (
    error.name !== 'NavigationDuplicated' &&
    !error.message.includes('Avoided redundant navigation to current location')
  ) {
    console.log(error)
  }
});
    },
  },
};
</script>